import { devToolsPlugin } from "@webplatform/dev-tools";
import Vue from "vue";
var dev_tools_default = ({ $config: { versionInfo, appEnv } }) => {
  Vue.use(devToolsPlugin, {
    consoleOnly: appEnv !== "dev",
    buildInfo: {
      versionInfo
    }
  });
};
export {
  dev_tools_default as default
};
